import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import { Message } from './util/message'
import './util/rem'
import {
  Image, Carousel,
  CarouselItem
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Image)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.prototype.$message = Message

// 创建事件总线
export const EventBus = new Vue()
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
